<template>
    <div class="page" v-if="imgUrl">
        <span class="back" @click="goBack"> < </span>
        <img :src="imgUrl" class="img">
    </div>
</template>

<script>
    export default {
        data(){
            return {
                imgUrl:''
            }
        },
        created() {
            const {imgUrl} = this.$route.query || {}
            this.imgUrl = imgUrl
        },
        methods:{
            goBack(){
                history.go(-1)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/review/detail';
</style>
